import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-crop-large.tsx
/**
* icon.24.crop.large
*
* Keywords: crop, trim, cut, resize, edit, adjust, frame, corners
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41IDNhLjUuNSAwIDAgMSAuNS41VjE2aDhWOEg5LjVhLjUuNSAwIDAgMSAwLTFoN2EuNS41IDAgMCAxIC41LjVWMTZoMy41YS41LjUgMCAwIDEgMCAxaC0xM2EuNS41IDAgMCAxLS41LS41VjhIMy41YS41LjUgMCAwIDEgMC0xSDdWMy41YS41LjUgMCAwIDEgLjUtLjVtOSAxNWEuNS41IDAgMCAxIC41LjV2MmEuNS41IDAgMCAxLTEgMHYtMmEuNS41IDAgMCAxIC41LS41IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-4196
*/
const Icon24CropLarge = memo(function Icon24CropLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7.5 3a.5.5 0 0 1 .5.5V16h8V8H9.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .5.5V16h3.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5V8H3.5a.5.5 0 0 1 0-1H7V3.5a.5.5 0 0 1 .5-.5m9 15a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24CropLarge };

//# sourceMappingURL=icon-24-crop-large.js.map